module.exports = __webpack_public_path__ + "img/html.65b6a151.png";